import type { DurationRange, SortKey } from "@/types/video";

interface FilterBarProps {
  sort: SortKey;
  onSortChange: (key: SortKey) => void;
  duration: DurationRange;
  onDurationChange: (range: DurationRange) => void;
}

const sortOptions: { key: SortKey; label: string }[] = [
  { key: "newest", label: "最新上传" },
  { key: "plays", label: "最多播放" },
  { key: "oldest", label: "最早发布" },
];

const durationOptions: { key: DurationRange; label: string }[] = [
  { key: "all", label: "全部时长" },
  { key: "short", label: "短视频" },
  { key: "medium", label: "中视频" },
  { key: "long", label: "长视频" },
];

function Segmented<T extends string>({
  options,
  value,
  onChange,
}: {
  options: { key: T; label: string }[];
  value: T;
  onChange: (key: T) => void;
}) {
  return (
    <div className="inline-flex items-center p-1 rounded-full bg-background-100 border border-background-200">
      {options.map((opt) => (
        <button
          key={opt.key}
          type="button"
          onClick={() => onChange(opt.key)}
          className={`px-3.5 py-1.5 text-sm rounded-full whitespace-nowrap transition-colors cursor-pointer ${
            value === opt.key
              ? "bg-primary-500 text-background-50 font-medium"
              : "text-foreground-600 hover:text-foreground-900"
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export default function FilterBar({ sort, onSortChange, duration, onDurationChange }: FilterBarProps) {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center flex-wrap gap-2">
        <span className="text-sm text-foreground-500 flex items-center gap-1 mr-1">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-sort-desc"></i>
          </span>
          排序
        </span>
        <Segmented options={sortOptions} value={sort} onChange={onSortChange} />
      </div>
      <div className="flex items-center flex-wrap gap-2">
        <span className="text-sm text-foreground-500 flex items-center gap-1 mr-1">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-time-line"></i>
          </span>
          时长
        </span>
        <Segmented options={durationOptions} value={duration} onChange={onDurationChange} />
      </div>
    </div>
  );
}